// Material
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';

const AlertMovementModal = ({ onSave, onClose, open }) => {
    const handleSave = () => {
        onSave();
        onClose();
    }
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Productos con cantidad = 0
            </DialogTitle>
            <DialogContent style={{ minWidth: 430 }}>
                <DialogContentText id="alert-dialog-description">
                Algunos de los productos cargados poseen cantidad = 0. Los mismos no se guardarán.<strong>¿Desea continuar?</strong>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={onClose} 
                    color="primary"
                >
                    Cancelar
                </Button>
                <Button 
                    onClick={handleSave} 
                    color="primary" 
                    variant='outlined'
                    autoFocus
                >
                    Continuar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AlertMovementModal;